module.exports = __webpack_public_path__ + "static/media/ml.48479612.pdf";